import placeholder_cover from '../assets/placeholder_cover.png';

function Image_Cover(props) {
  const { imgSrc, style, alt } = props;

  const addDefaultSrc = (e) => {
    if (e.target.src !== placeholder_cover) {
      e.target.src = placeholder_cover;
    }
  };

  return (
    <img
      onError={addDefaultSrc}
      src={imgSrc}
      style={style}
      alt={alt}
    />
  );
};

export default Image_Cover;
